import './../../components/spinner-overlay';
import './navigation/navigation';
import './header/header';
import './brand/brand';

import { html, LitElement} from 'lit';
import { customElement } from 'lit/decorators.js';
import { RouterService } from '../../services/router.service';
import { styles } from './app-layout.styles';

@customElement('lit-app-layout')
export class AppLayout extends LitElement {
    
    static get styles() {
        return [
            styles
        ];
    }

    constructor() {
        super();
    }

    protected render() {
        return html`
            <lit-brand></lit-brand>
            <lit-header></lit-header>
            <lit-navigation></lit-navigation>
            <div slot="router" id="router-outlet"></div>
        `;
    }
    
    protected async firstUpdated() {
        // Bootstrapping of everything except router (router needs outlet rendered) happens in loading component
        const outlet = (this as any).shadowRoot.getElementById('router-outlet');
        RouterService.init(outlet);
    }
}
